var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9024 3.43911L20.5609 4.09778C20.8416 4.37825 20.9995 4.75875 20.9999 5.15565V5.91412C21.0049 6.31791 20.8466 6.7066 20.5609 6.99194L18.7151 8.80828C18.6215 8.90274 18.4939 8.95588 18.3609 8.95588C18.2279 8.95588 18.1004 8.90274 18.0067 8.80828L15.2032 5.96402C15.013 5.76998 15.013 5.45945 15.2032 5.26542L17.009 3.43911C17.2943 3.15335 17.6829 2.99499 18.0866 2.99999H18.8448C19.2416 3.00034 19.622 3.15829 19.9024 3.43911ZM16.8195 10.6845C17.0096 10.4905 17.0096 10.1799 16.8195 9.9859L13.966 7.17158C13.8723 7.07711 13.7448 7.02398 13.6118 7.02398C13.4788 7.02398 13.3513 7.07711 13.2576 7.17158L5.20608 15.2253C5.01142 15.4183 4.85859 15.6493 4.75711 15.904L3.04105 20.2352C2.94383 20.4601 3.02415 20.7222 3.23061 20.854C3.37201 20.9952 3.58402 21.0384 3.76938 20.9638L8.09945 19.2073C8.35403 19.1058 8.58498 18.9529 8.7779 18.7582L16.8195 10.6845Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.6065e786.svg";
export { ForwardRef as ReactComponent };